import React, { useEffect, useState } from 'react'

import { SwitchWrapper } from './styles'
import { ISwitchProps } from './types'

function Switch(props: ISwitchProps) {
	const { isChecked, onChange, label, className, capture, ...rest } = props

	const [checkboxState, setCheckBoxState] = useState(isChecked)

	function handleCheckBoxState() {
		setCheckBoxState(!checkboxState)
		onChange(!checkboxState)
	}

	useEffect(() => {
		setCheckBoxState(isChecked)
	}, [isChecked])

	useEffect(() => {}, [checkboxState])

	return (
		<SwitchWrapper className={className}>
			<label className='switch'>
				<input
					type='checkbox'
					checked={checkboxState}
					onChange={handleCheckBoxState}
					{...rest}
				/>
				<span className='slider round' />
			</label>
			<span className='checkbox-label'>{label}</span>
		</SwitchWrapper>
	)
}

export default Switch
